import React from 'react'

const MainPage = () => {
  return (
    <div>
      {/*	Slider
        ===============================================================*/}
      <div className="full-row overflow-hidden p-0">
        <div id="image-slider-2" style={{ width: "1200px", height: "800px" }}>
          {/* Slide 1*/}
          <div
            className="ls-slide"
            data-ls="bgposition:50% 50%; duration:9000; transition2d:4; kenburnsscale:1.2;">
            {" "}
            <img
              width="1920"
              height="1080"
              src="images/slider/slider2.jpeg"
              className="ls-bg"
              alt=""
            />
            <div
              style={{
                top: "50%",
                left: "50%",
                textAlign: "initial",
                fontWeight: "400",
                fontStyle: "normal",
                textDecoration: "none",
                width: "100%",
                height: "100%",
              }}
              className="ls-l slider-layer-1"
              data-ls="showinfo:1; position:fixed; durationout:400;"></div>
            <p
              style={{
                fontWeight: "600",
                fontFamily: "Comfortaa",
                fontSize: "4rem",
                lineHeight: "76px",
                color: "#ffffff",
                top: "290px",
                left: "20px",
                whiteSpace: "nowrap",
              }}
              className="ls-l"
              data-ls="offsetyin:30; durationin:1000; delayin:300; offsetyout:-30; durationout:400; parallaxlevel:0;">
              Uttara Proborton City
            </p>

            <p
              style={{
                fontWeight: "bold",
                fontFamily: "Comfortaa",
                fontSize: "2rem",
                lineHeight: "20px",
                top: "260px",
                left: "20px",
                fontStyle: "italic"
              }}
              className="ls-l text-primary"
              data-ls="offsetyin:30; durationin:1000; delayin:150 offsetyout:-30; durationout:400; parallaxlevel:0;">
              Welcome To
            </p>

            <div
              style={{
                top: "410px",
                left: "53px",
                textAlign: "initial",
                fontWeight: "400",
                fontStyle: "normal",
                textDecoration: "none",
                height: "2px",
                width: "350px",
                background: "#adadad",
              }}
              className="ls-l"
              data-ls="showinfo:1; durationin:1000; delayin:1200; offsetyout:-30; durationout:400; scalexin:0;"></div>

          </div>

          {/* Slide 2*/}
          <div
            className="ls-slide"
            data-ls="bgposition:50% 50%; duration:9000; transition2d:4; kenburnsscale:1.2;">
            {" "}
            <img
              width="1920"
              height="1080"
              src="images/slider/slider1.jpeg"
              className="ls-bg"
              alt=""
            />
            <div
              style={{
                top: "50%",
                left: "50%",
                textAlign: "initial",
                fontWeight: "400",
                fontStyle: "normal",
                textDecoration: "none",
                width: "100%",
                height: "100%",
              }}
              className="ls-l slider-layer-1"
              data-ls="showinfo:1; position:fixed; durationout:400;"></div>
            <p
              style={{
                fontWeight: "600",
                fontFamily: "Comfortaa",
                fontSize: "4rem",
                lineHeight: "76px",
                color: "#ffffff",
                top: "290px",
                left: "20px",
                whiteSpace: "nowrap",
              }}
              className="ls-l"
              data-ls="offsetyin:30; durationin:1000; delayin:300; offsetyout:-30; durationout:400; parallaxlevel:0;">
              Uttara Proborton City
            </p>

            {/*  <p
              style={{
                fontWeight: "600",
                fontFamily: "Comfortaa",
                fontSize: "2.5rem",
                lineHeight: "20px",
                top: "260px",
                left: "50px",
              }}
              className="ls-l text-primary"
              data-ls="offsetyin:30; durationin:1000; delayin:150 offsetyout:-30; durationout:400; parallaxlevel:0;">
              Welcome To
            </p> */}

            <div
              style={{
                top: "410px",
                left: "53px",
                textAlign: "initial",
                fontWeight: "400",
                fontStyle: "normal",
                textDecoration: "none",
                height: "2px",
                width: "350px",
                background: "#adadad",
              }}
              className="ls-l"
              data-ls="showinfo:1; durationin:1000; delayin:1200; offsetyout:-30; durationout:400; scalexin:0;"></div>




          </div>

          {/* Slide 3*/}

          <div
            className="ls-slide"
            data-ls="bgposition:50% 50%; duration:9000; transition2d:4; kenburnsscale:1.2;">
            {" "}
            <img
              width="1920"
              height="1080"
              src="images/slider/03.jpg"
              className="ls-bg"
              alt=""
            />
            <div
              style={{
                top: "50%",
                left: "50%",
                textAlign: "initial",
                fontWeight: "400",
                fontStyle: "normal",
                textDecoration: "none",
                width: "100%",
                height: "100%",
              }}
              className="ls-l slider-layer-1"
              data-ls="showinfo:1; position:fixed; durationout:400;"></div>
            <p
              style={{
                fontWeight: "600",
                fontFamily: "Comfortaa",
                fontSize: "4rem",
                lineHeight: "76px",
                color: "#ffffff",
                top: "290px",
                left: "20px",
                whiteSpace: "nowrap",
              }}
              className="ls-l"
              data-ls="offsetyin:30; durationin:1000; delayin:300; offsetyout:-30; durationout:400; parallaxlevel:0;">
              Uttara Proborton City
            </p>

            {/*  <p
              style={{
                fontWeight: "600",
                fontFamily: "Comfortaa",
                fontSize: "2.5rem",
                lineHeight: "20px",
                top: "260px",
                left: "50px",
              }}
              className="ls-l"
              data-ls="offsetyin:30; durationin:1000; delayin:150 offsetyout:-30; durationout:400; parallaxlevel:0;">
              Welcome To
            </p> */}

            <div
              style={{
                top: "410px",
                left: "53px",
                textAlign: "initial",
                fontWeight: "400",
                fontStyle: "normal",
                textDecoration: "none",
                height: "2px",
                width: "350px",
                background: "#adadad",
              }}
              className="ls-l"
              data-ls="showinfo:1; durationin:1000; delayin:1200; offsetyout:-30; durationout:400; scalexin:0;"></div>
          </div>
        </div>
      </div>

      {/*	Text Box Five
        ===============================================================*/}
      {/*  <div className="full-row">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-xl-7">
              <div
                className="investment icon-primary icon-font video-popup position-relative"
                >
                {" "}
                <img src="images/image1.jpeg" alt="" />{" "}
                
              </div>
            </div>
            <div className="col-lg-6 col-xl-5">
              <h3 className="double-down-line-left text-secondary position-relative pb-4 mb-4">
                Investment Oppertunity
              </h3>
              <p className="pt-50">
                Best wishes on finding your dream home! Our Home Loan with its
                attractive features and competitive interest rates will help you
                make your dream home come in reality.
              </p>
              <div className="p-4 hover-bg-white hover-shadow rounded">
                {" "}
                <i
                  className="flaticon-budget flat-medium icon-primary float-left mr-3"
                  aria-hidden="true"></i>
                <div className="d-table">
                  <h5 className="text-secondary mb-3">
                    Invest start from $105,000
                  </h5>
                  <p>
                    Pretium hymenaeos hendrerit a cursus porttitor sagittis
                    metus hac gravida lacus volutpat.
                  </p>
                </div>
              </div>
              <div className="p-4 hover-bg-white hover-shadow rounded">
                {" "}
                <i
                  className="flaticon-increase flat-medium icon-primary float-left mr-3"
                  aria-hidden="true"></i>
                <div className="d-table">
                  <h5 className="text-secondary mb-3">
                    Profit up to 10 - 15 % per annum
                  </h5>
                  <p>
                    Pretium hymenaeos hendrerit a cursus porttitor sagittis
                    metus hac gravida lacus volutpat.
                  </p>
                </div>
              </div>
              <div className="p-4 hover-bg-white hover-shadow rounded">
                {" "}
                <i
                  className="flaticon-rent flat-medium icon-primary float-left mr-3"
                  aria-hidden="true"></i>
                <div className="d-table">
                  <h5 className="text-secondary mb-3">
                    Tenants or lease properties
                  </h5>
                  <p>
                    Pretium hymenaeos hendrerit a cursus porttitor sagittis
                    metus hac gravida lacus volutpat.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      */} {/*	Primary Deposit
        ===============================================================*/}
      {/*  <div className="full-row bg-gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="text-secondary double-down-line text-center">
                Instalment Property Booking
              </h2>
              <span className="text-center mt-4 d-block mb-5">
                After make a primary deposit you can be a ownner of a property
              </span>{" "}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-md-6 col-lg-4">
                  <div className="position-relative thumbnail-two hover-zoomer mb-4">
                    <div className="overlay-secondary overflow-hidden position-relative z-index-9">
                      {" "}
                      <img
                        style={{ height: '460px' }}
                        src="images/p-1.jpg"
                        alt="Image not found!"
                      />{" "}
                    </div>
                    <div className="position-absolute content text-white text-center">
                      <h4 className="text-white mb-4">Single Family Condos</h4>

                      <h5 className="mt-4">12% Primary Deposit</h5>
                      <span>----------------</span>{" "}
                    </div>
                    <a className="btn btn-primary w-100" href="#">
                      View More Details
                    </a>{" "}
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="position-relative thumbnail-two hover-zoomer mb-4">
                    <div className="overlay-secondary overflow-hidden position-relative z-index-9">
                      {" "}
                      <img
                        style={{ height: '460px' }}
                        src="images/UPC-29-6-18-2.jpg"
                        alt="Image not found!"
                      />{" "}
                    </div>
                    <div className="position-absolute content text-white text-center">
                      <h4 className="text-white mb-4">Appartment House</h4>

                      <h5 className="mt-4">8% Primary Deposit</h5>
                      <span>----------------</span>{" "}
                    </div>
                    <a className="btn btn-primary w-100" href="#">
                      View More Details
                    </a>{" "}
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="position-relative thumbnail-two hover-zoomer mb-4">
                    <div className="overlay-secondary overflow-hidden position-relative z-index-9">
                      {" "}
                      <img style={{ height: '460px' }}
                        src="images/GP-11.jpg"
                        alt="Image not found!"
                      />{" "}
                    </div>
                    <div className="position-absolute content text-white text-center">
                      <h4 className="text-white mb-4">Commercial Building</h4>

                      <h5 className="mt-4">20% Primary Deposit</h5>
                      <span>----------------</span>{" "}
                    </div>
                    <a className="btn btn-primary w-100" href="#">
                      View More Details
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

     */}  {/*	Text Block One
        ======================================================*/}
      {/*  <div className="full-row">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="text-secondary double-down-line text-center">
                What We Do
              </h2>
              <span className="text-center mt-4 d-block mb-5">
                We listed our oppertunity and servies as a real estate company
              </span>{" "}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <div className="py-5 px-4 text-center hover-bg-white hover-shadow rounded mb-4 transation-3s">
                {" "}
                <i
                  className="flaticon-house flat-medium text-primary"
                  aria-hidden="true"></i>
                <h5 className="text-secondary hover-text-primary py-3 m-0">
                  <a href="service-details.html">Client Happiness</a>
                </h5>
                <p>
                  Quam vestibulum sociis libero, pellentes vel montes purus
                  taciti vivamus sapien etiam montes. Nostra cras vulputate
                  luctu ipsum, ullamcorper ridiculus porta.
                </p>
                <a
                  className="text-primary hover-text-secondary mt-4 d-table mx-auto"
                  href="#">
                  Learn More
                </a>{" "}
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="py-5 px-4 text-center hover-bg-white hover-shadow rounded mb-4 transation-3s">
                {" "}
                <i
                  className="flaticon-diagram flat-medium text-primary"
                  aria-hidden="true"></i>
                <h5 className="text-secondary hover-text-primary py-3 m-0">
                  <a href="service-details.html">Safe Investment</a>
                </h5>
                <p>
                  Quam vestibulum sociis libero, pellentes vel montes purus
                  taciti vivamus sapien etiam montes. Nostra cras vulputate
                  luctu ipsum, ullamcorper ridiculus porta.
                </p>
                <a
                  className="text-primary hover-text-secondary mt-4 d-table mx-auto"
                  href="#">
                  Learn More
                </a>{" "}
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="py-5 px-4 text-center hover-bg-white hover-shadow rounded mb-4 transation-3s">
                {" "}
                <i
                  className="flaticon-rent flat-medium text-primary"
                  aria-hidden="true"></i>
                <h5 className="text-secondary hover-text-primary py-3 m-0">
                  <a href="service-details.html">Easy Processing</a>
                </h5>
                <p>
                  Quam vestibulum sociis libero, pellentes vel montes purus
                  taciti vivamus sapien etiam montes. Nostra cras vulputate
                  luctu ipsum, ullamcorper ridiculus porta.
                </p>
                <a
                  className="text-primary hover-text-secondary mt-4 d-table mx-auto"
                  href="#">
                  Learn More
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>

    */}   {/*	positive thinking
        ======================================================*/}
      {/*   <div className="bgstyleEffect full-row overlay-secondary">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="text-white">
                <h2 className="text-white double-down-line-left position-relative pb-4 mb-5">
                  <span className="h4 d-block">We Offer</span> 2-3 Days Delivery Time
                </h2>
                <p>
                  Malesuada hac lectus. Ligula donec. Sodales odio conubia
                  facilisis, sagittis velit rutrum sodales, conubia. Curae; nunc
                  conubia accumsan vitae congue ornare ultricies bibendum justo.
                  Mus sit porta luctus ultricies platea duis cum aliquam
                  tristique gravida accumsan orci velit lobortis posuere, eu
                  ullamcorper quam eget. Tempor urna, luctus leo parturient
                  augue.
                </p>
                <a className="btn btn-primary mt-4" href="#">
                  Download Brochure
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>

      */} {/*	Text Box Five
        ============================================================*/}
      {/* <div className="full-row bg-gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="text-secondary double-down-line text-center">
                Why Choose Us ?
              </h2>
              <span className="text-center mt-4 d-block mb-5">
                We listed our oppertunity and servies as a real estate company
              </span>{" "}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-4">
              <div className="mb-5">
                <h5 className="mb-3 text-secondary">Management Company</h5>
                <p>
                  Suspendisse nonummy pellentesq placerat. Malesuad aenean. Leo
                  curabitur ementum ultr. Rhoncus fusce ac eu nunc euismod ad
                  dignissim natoque. Penatib natoque arcu, sed sit.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="mb-5">
                <h5 className="mb-3 text-secondary">Probublity Research</h5>
                <p>
                  Suspendisse nonummy pellentesq placerat. Malesuad aenean. Leo
                  curabitur ementum ultr. Rhoncus fusce ac eu nunc euismod ad
                  dignissim natoque. Penatib natoque arcu, sed sit.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="mb-5">
                <h5 className="mb-3 text-secondary">Due Diligence</h5>
                <p>
                  Suspendisse nonummy pellentesq placerat. Malesuad aenean. Leo
                  curabitur ementum ultr. Rhoncus fusce ac eu nunc euismod ad
                  dignissim natoque. Penatib natoque arcu, sed sit.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="mb-5">
                <h5 className="mb-3 text-secondary">Help Investor</h5>
                <p>
                  Suspendisse nonummy pellentesq placerat. Malesuad aenean. Leo
                  curabitur ementum ultr. Rhoncus fusce ac eu nunc euismod ad
                  dignissim natoque. Penatib natoque arcu, sed sit.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="mb-5">
                <h5 className="mb-3 text-secondary">Investment Analysis</h5>
                <p>
                  Suspendisse nonummy pellentesq placerat. Malesuad aenean. Leo
                  curabitur ementum ultr. Rhoncus fusce ac eu nunc euismod ad
                  dignissim natoque. Penatib natoque arcu, sed sit.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="mb-5">
                <h5 className="mb-3 text-secondary">Right Structure</h5>
                <p>
                  Suspendisse nonummy pellentesq placerat. Malesuad aenean. Leo
                  curabitur ementum ultr. Rhoncus fusce ac eu nunc euismod ad
                  dignissim natoque. Penatib natoque arcu, sed sit.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      */} {/*	How it work
        ============================================================*/}
      {/*  <div className="full-row">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="text-secondary double-down-line text-center">
                How It Work
              </h2>
              <span className="text-center mt-4 d-block mb-5">
                We listed our oppertunity and servies as a real estate company
              </span>{" "}
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="icon-thumb-one text-center mb-5">
                <div className="bg-primary text-white rounded-circle position-absolute z-index-9">
                  1
                </div>
                <div className="left-arrow">
                  <i
                    className="flaticon-investor flat-medium icon-primary"
                    aria-hidden="true"></i>
                </div>
                <h5 className="text-secondary mt-5 mb-4">Discussion</h5>
                <p>
                  Nascetur cubilia sociosqu aliquet ut elit nascetur nullam duis
                  tincidunt nisl non quisque vestibulum platea ornare ridiculus.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="icon-thumb-one text-center mb-5">
                <div className="bg-primary text-white rounded-circle position-absolute z-index-9">
                  2
                </div>
                <div className="left-arrow">
                  <i
                    className="flaticon-search flat-medium icon-primary"
                    aria-hidden="true"></i>
                </div>
                <h5 className="text-secondary mt-5 mb-4">Files Review</h5>
                <p>
                  Nascetur cubilia sociosqu aliquet ut elit nascetur nullam duis
                  tincidunt nisl non quisque vestibulum platea ornare ridiculus.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="icon-thumb-one text-center mb-5">
                <div className="bg-primary text-white rounded-circle position-absolute z-index-9">
                  3
                </div>
                <div>
                  <i
                    className="flaticon-handshake flat-medium icon-primary"
                    aria-hidden="true"></i>
                </div>
                <h5 className="text-secondary mt-5 mb-4">Acquire</h5>
                <p>
                  Nascetur cubilia sociosqu aliquet ut elit nascetur nullam duis
                  tincidunt nisl non quisque vestibulum platea ornare ridiculus.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="icon-thumb-one text-center mb-5">
                <div className="bg-primary text-white rounded-circle position-absolute z-index-9">
                  4
                </div>
                <div className="left-arrow">
                  <i
                    className="flaticon-strategy flat-medium icon-primary"
                    aria-hidden="true"></i>
                </div>
                <h5 className="text-secondary mt-5 mb-4">Managment</h5>
                <p>
                  Nascetur cubilia sociosqu aliquet ut elit nascetur nullam duis
                  tincidunt nisl non quisque vestibulum platea ornare ridiculus.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="icon-thumb-one text-center mb-5">
                <div className="bg-primary text-white rounded-circle position-absolute z-index-9">
                  5
                </div>
                <div className="left-arrow">
                  <i
                    className="flaticon-diagram flat-medium icon-primary"
                    aria-hidden="true"></i>
                </div>
                <h5 className="text-secondary mt-5 mb-4">Survey</h5>
                <p>
                  Nascetur cubilia sociosqu aliquet ut elit nascetur nullam duis
                  tincidunt nisl non quisque vestibulum platea ornare ridiculus.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="icon-thumb-one text-center mb-5">
                <div className="bg-primary text-white rounded-circle position-absolute z-index-9">
                  6
                </div>
                <div>
                  <i
                    className="flaticon-money flat-medium icon-primary"
                    aria-hidden="true"></i>
                </div>
                <h5 className="text-secondary mt-5 mb-4">Collect</h5>
                <p>
                  Nascetur cubilia sociosqu aliquet ut elit nascetur nullam duis
                  tincidunt nisl non quisque vestibulum platea ornare ridiculus.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      */} {/*	Price Table 2
        ============================================================*/}
      {/*   <div className="full-row bg-primary angle-shape overflow-hidden">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="text-white double-down-line text-center">
                Simple Instalment Plan
              </h2>
              <span className="text-center mt-4 d-block mb-5 text-white">
                We listed our oppertunity and servies as a real estate company
              </span>{" "}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-6">
              <div className="bg-white position-relative z-index-9 mr-minus-50 mr-minus-sm-0">
                <h5 className="text-primary text-center py-4 divider">
                  Housing Properties
                </h5>
                <div className="value-percent p-5">
                  <div className="d-table pb-5">
                    <div className="text-secondary float-left mr-4">
                      Value + 5.7%
                      <small className="text-ordinary d-block">
                        For 30 instalment period
                      </small>
                    </div>
                    <div className="text-secondary float-left">
                      Value + 8.2%
                      <small className="text-ordinary d-block">
                        For 50 instalment period
                      </small>
                    </div>
                  </div>
                  <ul className="pb-5 font-mini">
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-primary mr-2"></i>
                      No setup, monthly or hidden fees.
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-primary mr-2"></i>
                      20% Primary diposit on total amount.
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-primary mr-2"></i>
                      Interest are appicable for instalment payment.
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-primary mr-2"></i>
                      Free reporting and support in this circle.
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-primary mr-2"></i>
                      Per month Instalment cycle.
                    </li>
                  </ul>
                </div>
                <div className="bg-gray text-center p-4 text-center">
                  {" "}
                  <a className="text-primary hover-text-secondary" href="#">
                    More Details
                  </a>{" "}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6">
              <div className="bg-secondary position-relative z-index-9 mt-5">
                <h5 className="text-white text-center py-4 divider">
                  Corporate Properties
                </h5>
                <div className="p-5 text-white">
                  <p className="text-center">
                    12.50 % Interest include to purchase corperate property with
                    instalment payment system
                  </p>
                  <ul className="pt-5 font-mini">
                    <li className="mb-3 text-white">
                      <i className="fas fa-check-circle text-primary mr-2"></i>
                      Max 10 years instalment period.
                    </li>
                    <li className="mb-3 text-white">
                      <i className="fas fa-check-circle text-primary mr-2"></i>
                      20% primary payment on booking.
                    </li>
                    <li className="mb-3 text-white">
                      <i className="fas fa-check-circle text-primary mr-2"></i>
                      First year insurance support.
                    </li>
                    <li className="mb-3 text-white">
                      <i className="fas fa-check-circle text-primary mr-2"></i>1
                      year free maintanence.
                    </li>
                  </ul>
                </div>
                <div className="bg-primary text-center p-4 text-center">
                  {" "}
                  <a className="text-white hover-text-secondary" href="#">
                    More Details
                  </a>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      */} {/*	Blog
		============================================================*/}
      {/* <div className="full-row">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="text-secondary double-down-line text-center">
                News & Media
              </h2>
              <span className="text-center mt-4 d-block mb-5">
                The most recent posted articles and valuable tips.
              </span>{" "}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-md-6 col-lg-4 mb-4">
                  <div className="hover-zoomer thumb-two shadow-one">
                    <div className="overlay-black overflow-hidden position-relative">
                      {" "}
                      <img src="images/blog/pic1-370x260.png" alt="image" />
                      <div className="date text-white position-absolute z-index-9">
                        November 26, 2018
                      </div>
                    </div>
                    <div className="p-4">
                      <h6 className="text-secondary hover-text-primary mb-4">
                        <a href="#">
                          Our team are working to provide the owneship of
                          property.
                        </a>
                      </h6>
                      <p>
                        with all modern facility “Uttara Probortan City” (Beside Uttara sector-10) give a great opportunity to purchase plots monthly installment or full payment.
                      </p>
                      <a
                        className="mt-3 text-primary hover-text-secondary"
                        href="#">
                        Read More
                      </a>{" "}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 mb-4">
                  <div className="hover-zoomer thumb-two shadow-one">
                    <div className="overlay-black overflow-hidden position-relative">
                      {" "}
                      <img src="images/blog/pic2-370x260.png" alt="image" />
                      <div className="date text-white position-absolute z-index-9">
                        November 10, 2018
                      </div>
                    </div>
                    <div className="p-4">
                      <h6 className="text-secondary hover-text-primary mb-4">
                        <a href="#">
                          Your investment is our heart, so you can stay in
                          relax.
                        </a>
                      </h6>
                      <p>
                        with all modern facility “Uttara Probortan City” (Beside Uttara sector-10) give a great opportunity to purchase plots monthly installment or full payment.
                      </p>
                      <a
                        className="mt-3 text-primary hover-text-secondary"
                        href="#">
                        Read More
                      </a>{" "}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4 mb-4">
                  <div className="hover-zoomer thumb-two shadow-one">
                    <div className="overlay-black overflow-hidden position-relative">
                      {" "}
                      <img src="images/blog/pic3-370x260.png" alt="image" />
                      <div className="date text-white position-absolute z-index-9">
                        October 31, 2018
                      </div>
                    </div>
                    <div className="p-4">
                      <h6 className="text-secondary hover-text-primary mb-4">
                        <a href="#">
                          What do you thinking for your family house.
                        </a>
                      </h6>
                      <p>
                        with all modern facility “Uttara Probortan City” (Beside Uttara sector-10) give a great opportunity to purchase plots monthly installment or full payment.
                      </p>
                      <a
                        className="mt-3 text-primary hover-text-secondary"
                        href="#">
                        Read More
                      </a>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

 */}
    </div>
  )
}

export default MainPage
